var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetableEtcHarvesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 5.33789C9.13477 4.47461 7.07617 5.00586 5.91406 6.43359L7.74023 8.25977C7.93945 8.45898 7.93945 8.79102 7.74023 9.02344C7.64062 9.12305 7.50781 9.15625 7.3418 9.15625C7.20898 9.15625 7.07617 9.12305 6.97656 9.02344L5.31641 7.33008L1.06641 16.0625C0.966797 16.2617 0.966797 16.4941 1.06641 16.7266C1.23242 17.0918 1.69727 17.2578 2.0625 17.0586L6.47852 14.9004L4.85156 13.2734C4.65234 13.0742 4.65234 12.709 4.85156 12.5098C5.08398 12.3105 5.41602 12.3105 5.61523 12.5098L7.50781 14.4023L10.8945 12.7422C11.6914 12.377 12.3555 11.7129 12.7871 10.8496C13.7832 8.82422 12.9199 6.33398 10.8945 5.33789ZM13.9492 4.17578C14.5801 2.81445 14.248 1.2207 12.9531 0.125C11.2598 1.51953 11.1934 3.71094 12.6875 5.17188L12.9531 5.4375C14.4141 6.93164 16.6055 6.86523 18 5.17188C16.9043 3.87695 15.3105 3.54492 13.9492 4.17578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetableEtcHarvesting);
export default __webpack_public_path__ + "static/media/vegetable_etc_harvesting.130f4482e7cbb3b302a5bcc7f2c6e57a.svg";
export { ForwardRef as ReactComponent };